import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { DebounceInput } from 'react-debounce-input';
import ModalConfirmar from '@common/modalConfirmar/modalConfirmar';
import {
	InputGroupButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Dropdown,
	Row,
	Col,
	Badge,
	InputGroup,
	Input,
	Button,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	FormGroup,
	Label,
	UncontrolledButtonDropdown,
	InputGroupAddon,
	InputGroupText,
} from 'reactstrap';
import { httpRequest } from '@common/util/api-common.util';
import { getUsuarioLocalStorage } from '../../../localStorage.util';
import * as commonActions from '@common/common.action';
import { acessoPermitido } from '../../../acessos.seguranca';
import * as acessos from '../../../acessos.const.util';
import './filtro.styles.css';
import FadeTransparentComponent from '@componentes/fade/fade.transparent.component';
import CommonFunctions from '@common/util/functions.common';
import WebapiCommon from '@common/util/webapi.common';
import * as actions from './filtro.action';
import initialState from './filtro.state';
import SelectComponent from '@componentes/select/select.component';
import SelectAsyncComponent from '@componentes/select/select-async.component';
import { BotaoComIcone } from 'vivace-fluent-motion';
import IntlMessage from '../../../helpers/intlMessage';
import { enumFiltroPesquisa } from '@common/util/defaultValues';
import { format, subDays } from 'date-fns';
import { changePeriod, getDate, obterListagemDePeriodos } from '../../../helpers';

class FiltroContainer extends Component {
	constructor() {
		super();
		this.state = {
			paginaAnterior: 1,
			favoritosId: null,
			modalConfirmar: false,
			modalConfirmarTitulo: '',
			modalConfirmarMensagem: '',
			modalConfirmarType: 'confirm',
			modalConfirmarClick: () => { },
			period: '',
			periods: []
		};

		this.enumFiltros = enumFiltroPesquisa;
		this.select = this.select.bind(this);
		this.getDate = getDate.bind(this);
		this.filtro = this.filtro.bind(this);
		this.changeIntervalPeriod = this.changeIntervalPeriod.bind(this);
		this.limpar = this.limpar.bind(this);
		this.getPeriodos = obterListagemDePeriodos.bind(this);
		this.translate = this.translate.bind(this);
		this.showModalFavorito = this.showModalFavorito.bind(this);
		this.salvarFiltroFavorito = this.salvarFiltroFavorito.bind(this);
		this.atualizarLabelFiltroStatus = this.atualizarLabelFiltroStatus.bind(this);
		this.usuarioLocalStorage = getUsuarioLocalStorage();
		this.tipoEnum = {
			Select: 0,
			Input: 1,
			Status: 2,
			Data: 3,
			SelectComEtapa: 4,
		};
		this.cidDigitado = '';
	}
	componentDidMount() {
		this.buscaNrExame.focus();

		this.setState({
			modalConfirmarTitulo: this.translate('dashboards.examDetail.headsUp'),
			periods: this.getPeriodos(this.props.intl)
		});
	}
	componentDidUpdate(prevProps) {
		if (
			this.props.filtros &&
			JSON.stringify(this.props.filtros) !== JSON.stringify(prevProps.filtros)
		) {
			this.props.actions.filtros(this.props.filtros.filtros);
			let filtrosSelecionados = this.props.filtrosReducer.filtrosSelecionados;
			if (this.props.filtros.error === undefined) {
				this.props.filtros.filtros.forEach((el) => {
					switch (el.tipo) {
						default:
						case this.tipoEnum.Input:
							if (
								el.valoresDefault &&
								filtrosSelecionados.indexOf(el.valoresDefault) < 0
							) {
								filtrosSelecionados.push({
									id: el.id,
									param: el.label,
									value: el.valoresDefault,
								});
							}
							break;
						case this.tipoEnum.Select:
						case this.tipoEnum.SelectComEtapa:
						case this.tipoEnum.Status:
							if (el.valoresDefault) {
								el.valoresDefault.forEach((item) => {
									filtrosSelecionados.indexOf(item.value) < 0 &&
										filtrosSelecionados.push({
											id: el.id,
											param: el.label,
											value: item.value,
										});
								});
							}
							break;
						case this.tipoEnum.Data:
							if (el.valoresDefault) {
								el.valoresDefault.forEach((item) => {
									filtrosSelecionados.indexOf(item.value) < 0 &&
										filtrosSelecionados.push({
											id: el.id,
											param: item.label,
											value: item.value,
										});
								});
							}
							break;
					}
				});
			}

			this.props.actions.filtrosSelecionados(filtrosSelecionados);

			if (this.props.filtros.default) {
				this.props.filtrar(filtrosSelecionados, this.props.pagina);
			}
		}

		if (
			JSON.stringify(this.props.favoritos) !==
			JSON.stringify(prevProps.favoritos)
		) {
			const favorito = this.props.favoritos.filter(
				(filter) => filter.isDefault
			);
			this.props.actions.favoritos(this.props.favoritos);
			favorito &&
				favorito.length > 0 &&
				this.props.actions.labelFavoritoSelecionado(favorito[0].label);
		}

		if (this.props.grupoUsuarios !== prevProps.grupoUsuarios) {
			this.props.actions.grupoUsuarios(this.props.grupoUsuarios);
		}

		if (
			this.props.pagina > 1 &&
			JSON.stringify(this.props.filtros) === JSON.stringify(prevProps.filtros)
		) {
			if (this.props.pagina > this.state.paginaAnterior) {
				this.props.commonActions.showFadeCarregando(true);
				this.props.filtrar(
					this.props.filtrosReducer.filtrosSelecionados,
					this.props.pagina
				);
				this.setState({ paginaAnterior: this.props.pagina });
			}
		} else {
			if (
				this.props.pagina === 1 &&
				this.state.paginaAnterior > this.props.pagina
			) {
				this.setState({ paginaAnterior: 1 });
			}
		}
	}

	translate(key) {
		return this.props.intl.formatMessage({
			id: key,
		})
	}

	getPeriodosSubDays(days) {
		return {
			periodoInicial: format(subDays(new Date(), Number(days)), 'yyyy-MM-dd'),
			periodoFinal: format(new Date(), 'yyyy-MM-dd'),
		};
	}

	remover(param, value) {
		let filtrosSelecionados = [
			...this.props.filtrosReducer.filtrosSelecionados,
		];
		let index = filtrosSelecionados.findIndex(
			(t) => t.param === param && t.value === value
		);
		let filtro = filtrosSelecionados[index];
		const paramStatusEtapa = 'Status da etapa';
		const paramEtapa = 'Etapa';
		const idFiltrosTipoData = ['23', '24', '25'];

		if (
			filtro !== null &&
			idFiltrosTipoData.findIndex((el) => el === filtro.id) > -1
		) {
			filtrosSelecionados = filtrosSelecionados.filter(
				(el) => el.id !== filtro.id
			);
		} else {
			filtrosSelecionados.splice(index, 1);
		}

		if (param === paramEtapa) {
			index = filtrosSelecionados.findIndex(
				(t) => t.param === 'Médico executante'
			);

			if (index > -1) {
				filtrosSelecionados.splice(index, 1);
			}

			index = filtrosSelecionados.findIndex(
				(t) => t.param === 'Médico revisor'
			);

			if (index > -1) {
				filtrosSelecionados.splice(index, 1);
			}

			filtrosSelecionados = filtrosSelecionados.filter(
				(el) => el.param !== paramStatusEtapa
			);
		}

		if (
			param === paramStatusEtapa &&
			filtrosSelecionados.findIndex((el) => el.param === paramStatusEtapa) ===
			-1
		) {
			index = filtrosSelecionados.findIndex((t) => t.param === paramEtapa);

			if (index > -1) {
				filtrosSelecionados.splice(index, 1);
			}
		}

		this.props.actions.filtrosSelecionados(filtrosSelecionados);
		this.props.filtrar(filtrosSelecionados);
	}

	filtroTemporarioParaClienteFelicioRocho(id, label, value) {
		if (!value) {
			return;
		}

		let filtrosSelecionados = [];

		if (this.props.filtrosReducer.filtrosSelecionados&& this.props.filtrosReducer.filtrosSelecionados.length > 0) {
			this.props.filtrosReducer.filtrosSelecionados.forEach((filtro) => {
				if (
					filtro.id !== id &&
					!((id === '0' || id === '19') && filtro.id === '-1')
				) {
					filtrosSelecionados.push(filtro);
				}
			});
		} else if (this.props.filtrosReducer.tipoFiltroSelecionado == 'date' && this.componenteBuscaDate && this.componenteBuscaDate.value !== '') {
			filtrosSelecionados.push({
				id: this.props.filtrosReducer.idFiltroSelecionado,
				value: this.componenteBuscaDate.value,
				param: this.props.filtrosReducer.labelFiltroSelecionado
			});
		} else if (this.props.filtrosReducer.tipoFiltroSelecionado == 'text' && this.componenteBusca && this.componenteBusca.value !== '') {
			filtrosSelecionados.push({
				id: this.props.filtrosReducer.idFiltroSelecionado,
				value: this.componenteBusca.value,
				param: this.props.filtrosReducer.labelFiltroSelecionado
			});
		}

		filtrosSelecionados.push({
			id: id,
			value: value,
			param:
				label.toLowerCase() === 'status'
					? this.props.filtrosReducer.labelFiltroStatusSelecionado
					: label,
		});

		this.props.actions.filtrosSelecionados(filtrosSelecionados);
		this.props.actions.inputVazio(false);

		this.props.filtrar(filtrosSelecionados);

		this.limparCamposTemporarioFelicioRocho();
	}

	limparCamposTemporarioFelicioRocho() {
		this.buscaProntuario.value = '';
		this.buscaNrExame.value = '';
		this.buscaPaciente.value = '';
		this.buscaAtendimento.value = '';
	}

	parametroTemporarioFelicioRochoInformado() {
		return (
			!!this.buscaProntuario.value ||
			!!this.buscaNrExame.value ||
			!!this.buscaPaciente.value ||
			!!this.buscaAtendimento.value
		);
	}

	adicionarButton(event) {
		if (this.parametroTemporarioFelicioRochoInformado()) {
			let param = {};

			if (!!this.buscaProntuario.value) {
				param = {
					id: 14,
					label: 'Prontuário',
					value: this.buscaProntuario.value,
				};
			}

			if (!!this.buscaNrExame.value) {
				param = {
					id: 8,
					label: 'Número exame',
					value: this.buscaNrExame.value,
				};
			}

			if (!!this.buscaPaciente.value) {
				param = {
					id: 12,
					label: 'Paciente',
					value: this.buscaPaciente.value,
				};
			}

			if (!!this.buscaAtendimento.value) {
				param = {
					id: 13,
					label: 'Atendimento',
					value: this.buscaAtendimento.value,
				};
			}

			return this.filtroTemporarioParaClienteFelicioRocho(
				param.id,
				param.label,
				param.value
			);
		}

		return this.filtro(event);
	}

	onKeyDown(event) {
		if (event.key === 'Enter' && event && event.currentTarget) {
			this.filtro(event);
			//this.componenteBuscaSelect.blur();
		}
	}

	filtro(event) {
		if (this.props.filtrosReducer.tipoFiltroSelecionado === 'text') {
			if (this.componenteBusca.value === '') {
				this.props.actions.inputVazio(true);
			} else {
				this._filtro(this.componenteBusca.value);
				this.componenteBusca.value = '';
			}
		}

		if (this.props.filtrosReducer.tipoFiltroSelecionado === 'selectComEtapa') {
			this._filtro(event.currentTarget.value);
			if (event.currentTarget.value !== '') {
				this.props.actions.valorFiltro(event.currentTarget.value);
				this.props.actions.statusEtapaSelecionada(event.currentTarget);
			}
		}

		if (this.props.filtrosReducer.tipoFiltroSelecionado === 'select') {
			this._filtro(event.value);
			if (event.value) {
				this.props.actions.valorFiltro(event.value);
				this.props.actions.statusEtapaSelecionada(event);
			}
		}

		if (this.props.filtrosReducer.tipoFiltroSelecionado === 'date') {
			if (this.validarData()) {
				this._filtro(null);

				if (this.componenteBuscaDate) {
					this.componenteBuscaDate.value = '';
				}
			}
		}
	}

	removerFiltroIgual(idFiltro) {
		let filtrosSelecionados = [];
		this.props.filtrosReducer.filtrosSelecionados &&
			this.props.filtrosReducer.filtrosSelecionados.forEach((filtro) => {
				if (
					filtro.id !== idFiltro &&
					!(
						(idFiltro === '0' || idFiltro === '19' || idFiltro === '22') &&
						filtro.id === '-1'
					)
				) {
					filtrosSelecionados.push(filtro);
				}
			});
		return filtrosSelecionados;
	}

	_filtro(value) {
		let filtrosSelecionados = [];

		if ((value === '' || value === undefined) &&
			(this.props.filtrosReducer.tipoFiltroSelecionado === 'select' || this.props.filtrosReducer.tipoFiltroSelecionado === 'selectComEtapa'))
		{
			value = this.props.filtrosReducer.valorFiltro;
		}

		if (this.props.filtrosReducer.idFiltroSelecionado !== '30' && this.props.filtrosReducer.idFiltroSelecionado !== '22')
		{
			filtrosSelecionados = this.removerFiltroIgual(this.props.filtrosReducer.idFiltroSelecionado);
		} else
		{
			this.props.filtrosReducer.filtrosSelecionados.forEach((filtro) => {filtrosSelecionados.push(filtro);});
		}

		if (this.props.filtrosReducer.tipoFiltroSelecionado === 'date')
		{
			if (this.props.filtrosReducer.labelFiltroSelecionado === 'Data de solicitação')
			{
				filtrosSelecionados.push({
					id: this.props.filtrosReducer.idFiltroSelecionado,
					value: this.props.filtrosReducer.periodoDe,
					param: 'Data de solicitação de',
				});
				filtrosSelecionados.push({
					id: this.props.filtrosReducer.idFiltroSelecionado,
					value: this.props.filtrosReducer.periodoAte,
					param: 'Data de solicitação até',
				});
			} else if (this.props.filtrosReducer.labelFiltroSelecionado === 'Data de entrega')
			{
				filtrosSelecionados.push({
					id: this.props.filtrosReducer.idFiltroSelecionado,
					value: this.props.filtrosReducer.periodoDe,
					param: 'Data de entrega de',
				});
				filtrosSelecionados.push({
					id: this.props.filtrosReducer.idFiltroSelecionado,
					value: this.props.filtrosReducer.periodoAte,
					param: 'Data de entrega até',
				});
			} else if (this.props.filtrosReducer.labelFiltroSelecionado === 'Data de liberação')
			{
				filtrosSelecionados.push({
					id: this.props.filtrosReducer.idFiltroSelecionado,
					value: this.props.filtrosReducer.periodoDe,
					param: 'Data de liberação de',
				});
				filtrosSelecionados.push({
					id: this.props.filtrosReducer.idFiltroSelecionado,
					value: this.props.filtrosReducer.periodoAte,
					param: 'Data de liberação até',
				});
			} else if (this.props.filtrosReducer.labelFiltroSelecionado === 'Data de nascimento')
			{
				filtrosSelecionados.push({
					id: this.props.filtrosReducer.idFiltroSelecionado,
					value: this.props.filtrosReducer.dataNascimento,
					param: 'Data de nascimento'
				})
			} else {
				filtrosSelecionados.push({
					id: this.props.filtrosReducer.idFiltroSelecionado,
					value: this.props.filtrosReducer.periodoDe,
					param: 'Data não conformidade de',
				});
				filtrosSelecionados.push({
					id: this.props.filtrosReducer.idFiltroSelecionado,
					value: this.props.filtrosReducer.periodoAte,
					param: 'Data não conformidade até',
				});
			}
		} else
		{
			if (this.props.filtrosReducer.tipoFiltroSelecionado === 'selectComEtapa')
			{
				filtrosSelecionados = filtrosSelecionados.filter((x) => x.id !== -1 && x.param !== 'Etapa');

				filtrosSelecionados.push({
					id: -1,
					value: this.props.filtrosReducer.etapaFiltro,
					param: 'Etapa',
				});

				filtrosSelecionados.push({
					id: this.props.filtrosReducer.idFiltroSelecionado,
					value: value,
					param: this.props.filtrosReducer.labelFiltroSelecionado,
				});
			} else if (this.props.filtrosReducer.labelFiltroSelecionado === 'Status da etapa')
			{
				const pEtapa = 'Etapa';
				const pStatus = 'Status da etapa';
				let posicao = undefined;
				let etapa = filtrosSelecionados.find((el) => el.param === pEtapa);
				let label = this.props.filtrosReducer.labelFiltroStatusSelecionado;

				if (!!etapa && etapa.value !== label)
				{
					posicao = filtrosSelecionados.findIndex((el) => el.param === pEtapa);

					if (posicao > -1)
						filtrosSelecionados.splice(posicao, 1);

					filtrosSelecionados = filtrosSelecionados.filter((el) => el.param !== pStatus);
				}

				if ((etapa === undefined || etapa.value !== label) && value)
				{
					filtrosSelecionados.push({
						id: -1,
						value: label,
						param: pEtapa,
					});
				}

				const isStatusEtapaExiste = filtrosSelecionados.find(
					(x) =>
						x.id === this.props.filtrosReducer.idFiltroSelecionado &&
						x.value === value &&
						x.param === pStatus
				);

				if (!isStatusEtapaExiste && value)
					filtrosSelecionados.push({
						id: this.props.filtrosReducer.idFiltroSelecionado,
						value: value,
						param: pStatus,
					});
			} else
			{
				filtrosSelecionados = filtrosSelecionados.filter(
					(x) =>
						x.id === this.props.filtrosReducer.idFiltroSelecionado &&
						x.value !== value &&
						x.param === this.props.filtrosReducer.labelFiltroSelecionado
				);
				filtrosSelecionados.push({
					id: this.props.filtrosReducer.idFiltroSelecionado,
					value: value,
					param: this.props.filtrosReducer.labelFiltroSelecionado,
				});
			}
		}

		this.props.actions.filtrosSelecionados(filtrosSelecionados);
		this.props.actions.inputVazio(false);

		this.props.filtrar(filtrosSelecionados);
	}

	select(label, id, tipo, url) {
		switch (tipo) {
			case 0:
				if (url !== '') {
					this.props.carregando(true);
					httpRequest(url).then((json) => {
						this.props.carregando(false);
						this._select(label, 'select', id, json.data);
						this.props.actions.valorFiltro(json.data[0].value);
						this.props.actions.statusEtapaSelecionada(null);
					});
				}
				break;
			case 1:
				this._select(label, 'text', id, []);
				break;
			case 2:
				this._select(label, 'select', id, [
					{
						label: 'Realizado',
						value: 'S',
					},
					{
						label: 'Não realizado',
						value: 'N',
					},
				]);
				break;
			case 3:
				this._select(label, 'date', id, []);
				break;
			case 4:
				if (url !== '') {
					this.props.carregando(true);
					httpRequest(url).then((json) => {
						this.props.carregando(false);
						this._select(label, 'selectComEtapa', id, json.data);
						this.props.actions.valorFiltro(json.data[0].value);
						this.props.actions.statusEtapaSelecionada(json.data[0]);
					});
				}
				break;
			default:
				break;
		}
	}

	_select(label, tipo, id, options) {
		this.props.actions.idFiltroSelecionado(id);
		this.props.actions.optionsFiltroInputTypeSelect(options);
		this.props.actions.tipoFiltroSelecionado(tipo);
		this.props.actions.labelFiltroSelecionado(label);

		if (tipo === 'select') {
			//this.componenteBuscaSelect.focus();
		} if (tipo === 'date') {
			if (label === 'data de nascimento') {
				this.componenteBuscaDate.value = '';
				this.componenteBuscaDate.focus();
			}
		}else {
			this.componenteBusca.value = '';
			this.componenteBusca.focus();
		}
	}

	limpar() {
		if (this.props.filtrosReducer.labelFiltroSelecionado == 'Data de nascimento' && this.componenteBuscaDate) {
			this.props.actions.dataNascimento('');
			this.componenteBuscaDate.value = '';
		}

		this.props.actions.labelFavoritoSelecionado('Favoritos');
		this.props.actions.filtrosSelecionados([]);
		this.props.filtrar([]);
	}

	showModalFavorito() {
		this.props.actions.showModalFavoritos(
			!this.props.filtrosReducer.showModalFavoritos
		);
		this.props.actions.tituloNovoFiltroFavorito('');
		this.props.actions.labelGruposUsuario('');
		this.props.actions.idGrupoUsuario(undefined);

		if (this.props.filtrosReducer.grupoUsuarios.length == 0) {
			Promise.all([WebapiCommon.getGrupoUsuarios()]).then((responseArray) => {
				const [grupos] = responseArray;
				this.props.actions.grupoUsuarios(grupos);
				this.props.filtrosReducer.grupoUsuarios = grupos;
			});
		}
	}

	salvarFiltroFavorito() {
		const {
			filtrosSelecionados,
			tituloNovoFiltroFavorito,
			novoFiltroFavoritoIsDefault,
			idGrupoUsuario,
		} = this.props.filtrosReducer;

		if (
			!tituloNovoFiltroFavorito ||
			tituloNovoFiltroFavorito.trim().length < 1
		) {
			this.props.commonActions.showAlerta(
				'Alerta',
				'Informe um título para o filtro favorito.',
				2000,
				'350px'
			);
		} else if (filtrosSelecionados.length > 0) {
			const usuarioLocalStorage = getUsuarioLocalStorage();
			let filtroFavorito = [];
			filtrosSelecionados.forEach((filtro) => {
				filtroFavorito.push({
					id: filtro.id,
					valor: filtro.value,
				});
			});
			const filtroFavoritoRequest = {
				usuarioId: usuarioLocalStorage.usuarioId,
				nome: tituloNovoFiltroFavorito,
				isDefault: novoFiltroFavoritoIsDefault,
				filtroFavorito: filtroFavorito,
				seggrpId: idGrupoUsuario,
			};
			httpRequest(
				'filtro/favoritos/filtros',
				'POST',
				filtroFavoritoRequest
			).then((json) => {
				this.props.actions.favoritos(json.data);
				this.showModalFavorito();
			});
		} else {
			this.props.commonActions.showAlerta(
				'alerta',
				'Informe ao menos um parâmetro no filtro antes de salvar o favorito',
				2000,
				'550px'
			);
		}
	}

	atualizarLabelFiltroStatus(event) {
		let label = event.currentTarget.innerText;
		let opcoes = [
			{
				label: 'Realizado',
				value: 'S',
			},
			{
				label: 'Não realizado',
				value: 'N',
			},
		];

		if (
			!(
				label === 'Recebimento Material' ||
				label === 'Impresso' ||
				label === 'Setor'
			)
		) {
			opcoes.push({
				label: 'Pendente',
				value: 'P',
			});
		}

		if (
			!(
				label === 'Recebimento Material' ||
				label === 'Congelação' ||
				label === 'Errata' ||
				label === 'Impresso'
			)
		) {
			opcoes.push({
				label: 'Revisão',
				value: 'R',
			});
		}

		if (
			!(
				label === 'Recebimento Material' ||
				label === 'Nota' ||
				label === 'Errata' ||
				label === 'Impresso'
			)
		) {
			opcoes.push({
				label: 'Conferencia',
				value: 'Z',
			});
		}

		this.props.actions.labelFiltroStatusSelecionado(label);
		this.props.actions.optionsFiltroInputTypeSelect(opcoes);
		this.props.actions.statusEtapaSelecionada(null);
		this.props.actions.valorFiltro(null);
	}

	validarEntradaEnter(event) {
		if (event.keyCode === 13) {
			if (this.validarData()) {
				this.filtro(event);
			}
		}
	}

	validarData() {
		if (this.props.filtrosReducer.labelFiltroSelecionado === 'Data de nascimento') {
			if (this.componenteBuscaDate && this.componenteBuscaDate.value === '') {
				this.props.commonActions.showAlerta('alerta', this.translate('dashboards.examDetails.errorDate'), 2000);

				return false;
			}
		}

		if (
			this.props.filtrosReducer.periodoDe === undefined ||
			this.props.filtrosReducer.periodoDe === ''
		) {
			this.props.commonActions.showAlerta(
				'alerta',
				'Por favor, Informe uma Data Inicial Válida!',
				2000
			);
			return false;
		}

		if (
			this.props.filtrosReducer.periodoAte === undefined ||
			this.props.filtrosReducer.periodoAte === ''
		) {
			this.props.commonActions.showAlerta(
				'alerta',
				'Por favor, Informe uma Data Final Válida!',
				2000
			);
			return false;
		}

		var dtInicial = new Date(this.props.filtrosReducer.periodoDe).getTime();
		var dtFinal = new Date(this.props.filtrosReducer.periodoAte).getTime();
		if (dtInicial > dtFinal) {
			this.props.commonActions.showAlerta(
				'alerta',
				'A data inicial é superior a data final',
				2000
			);
			return false;
		}

		var oneday = 1000 * 60 * 60 * 24;
		var diff_ms = Math.abs(dtFinal - dtInicial);
		var diff_days = Math.round(diff_ms / oneday);

		if (diff_days > 366) {
			this.props.commonActions.showAlerta(
				'alerta',
				this.translate('dashboards.general.consultationGreater1Year'),
				2000
			);
			return false;
		}

		return true;
	}

	atualizarEtapaFiltro(event) {
		this.props.actions.etapaFiltro(event.currentTarget.value);

		var exist = false;
		var filtrosSelecionados = [];
		this.props.filtrosReducer.filtrosSelecionados.forEach((filtro) => {
			if (filtro.id === '-1') {
				filtro.value = event.currentTarget.value;
				exist = true;
			}
			filtrosSelecionados.push(filtro);
		});

		if (exist) {
			this.props.actions.filtrosSelecionados(filtrosSelecionados);
			this.props.actions.inputVazio(false);
			this.componenteFiltro.focus();
			this.props.filtrar(filtrosSelecionados);
		}
	}

	atualizarFiltroFavoritoDefault(idfiltrousuario) {
		this.props.commonActions.showFadeCarregando(true);
		WebapiCommon.updateFiltroFavoritoDefault(
			this.usuarioLocalStorage.usuarioId,
			idfiltrousuario
		).then(() => {
			WebapiCommon.getFiltrosFavoritosUsuario(
				this.usuarioLocalStorage.usuarioId
			).then((re) => {
				this.props.commonActions.preencherFavoritos(re);
				this.props.commonActions.showFadeCarregando(false);
			});
		});
	}

	abrirModalDeletar(favorito) {
		const mensagem = `Deseja realmente deletar o cenário ${favorito.label}`;
		this.setState({
			favoritosId: favorito.value,
			modalConfirmar: true,
			modalConfirmarMensagem: mensagem,
			modalConfirmarClick: () => {
				this.deletarFiltroFavoritoDefault(this.state.favoritosId);
			},
		});
	}

	deletarFiltroFavoritoDefault(idfiltrousuario) {
		this.props.commonActions.showFadeCarregando(true);
		WebapiCommon.deleteFiltroFavoritoDefault(idfiltrousuario).then(() => {
			WebapiCommon.getFiltrosFavoritosUsuario(
				this.usuarioLocalStorage.usuarioId
			).then((re) => {
				this.props.commonActions.preencherFavoritos(re);
				this.props.commonActions.showFadeCarregando(false);
			});
		});
		this.setState({
			modalConfirmar: false,
		});
	}

	 resetPeriods = () => {
		this.props.actions.periodoDe('');
		this.props.actions.periodoAte('');
		this.setState({period:''})
	}

	periodChanged = (e) => {
		if (!e || !e.value) {
		  return this.resetPeriods();
		}
		const customPeriodo = e.value;
		const payload = this.getDate(customPeriodo);
		if (payload.dtinicial) {
			this.props.actions.periodoDe(payload.dtinicial.toISOString().slice(0, 10));
		}
		if (payload.dtfinal) {
			this.props.actions.periodoAte(payload.dtfinal.toISOString().slice(0, 10));
		}

		this.setState({period:e})
	}

	changeIntervalPeriod = (val) => {
		const period = changePeriod(val);
		this.props.actions.periodoDe(period.start);
		this.props.actions.periodoAte(period.end);
	  }

	setCidDigitado = (valor) => {
		this.cidDigitado = valor;
	}

	obterCIDPorTermo = (valor) =>
	  	new Promise((resolve) => {
			if (valor.length < 3)
		  		return;

		const request = [WebapiCommon.getMorfologiaPorTermo(valor)];
		Promise.all(request)
			.then((res) => {
				resolve(res[0]);
			})
			.catch((err) => {
				resolve(err);
			});
	  });

	  validarCpf = (val) => {
		let _cpf = val;
		if (val.length === 11 && val.indexOf('.') < 0) {
			_cpf = _cpf
				.replace(/(\d{3})(\d)/, '$1.$2')
				.replace(/(\d{3})(\d)/, '$1.$2')
				.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
		} else if (val.length < 12) {
			_cpf = _cpf.replace(/(\d{3})(\d)/, '$1.$2');
		} else {
			_cpf = _cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
		}

		this.componenteBusca.value = _cpf;
	}

	render() {
		return (
			<div className="filtro-container">
				<ModalConfirmar
					toggleModalConfirmar={() =>
						this.setState({
							modalConfirmar: !this.state.modalConfirmar,
						})
					}
					type={this.state.modalConfirmarType}
					showModalConfirmar={this.state.modalConfirmar}
					titulo={this.state.modalConfirmarTitulo}
					mensagem={this.state.modalConfirmarMensagem}
					confirmar={this.state.modalConfirmarClick}
				/>
				<FadeTransparentComponent visible={this.props.showLoading} />
				<Modal
					isOpen={this.props.filtrosReducer.showModalFavoritos}
					toggle={this.showModalFavorito}
				>
					<ModalHeader toggle={this.showModalFavorito}>
						<IntlMessage id="dashboards.examDetail.saveFilter" />
					</ModalHeader>
					<ModalBody>
						<FormGroup>
							<Label>
								<IntlMessage id="dashboards.examDetails.filterName" />
							</Label>
							<Input
								value={this.props.filtrosReducer.tituloNovoFiltroFavorito}
								onChange={(event) => {
									this.props.actions.tituloNovoFiltroFavorito(
										event.currentTarget.value
									);
								}}
							/>
						</FormGroup>
						{acessoPermitido(this.props.usuario, acessos.Web) &&
							acessoPermitido(
								this.props.usuario,
								acessos.FiltroGrupoUsuario
							) && (
								<FormGroup>
									<Dropdown
										isOpen={this.props.filtrosReducer.dropdownOpenGrupoUsuario}
										direction="down"
										toggle={() =>
											this.props.actions.dropdownOpenGrupoUsuario(
												!this.props.filtrosReducer.dropdownOpenGrupoUsuario
											)
										}
									>
										<DropdownToggle
											style={{
												width: '100%',
												backgroundColor: 'transparent',
												color: '#000',
												borderRadius: '0',
												borderColor: '#ced4da',
												fontSize: '13px',
												height: '38px',
											}}
											className="button"
											caret
										>
											<span>
												<IntlMessage id="dashboards.examDetails.visibleGroupUsers" />
											</span>{' '}
											{this.props.filtrosReducer.labelGruposUsuario}
										</DropdownToggle>
										<DropdownMenu>
											<div
												style={{
													maxHeight: `${window.innerHeight - 300}px`,
													overflowY: 'scroll',
													overflowX: 'hidden',
												}}
											>
												{this.props.filtrosReducer.grupoUsuarios.map(
													(grupoUsuarios, i) => {
														return (
															<div style={{ position: 'relative' }} key={i}>
																<DropdownItem
																	style={{
																		fontSize: '12px',
																		overflow: 'hidden',
																		textOverflow: 'ellipsis',
																		whiteSpace: 'nowrap',
																		width: '250px',
																		paddingLeft: '10px',
																	}}
																	onClick={() => {
																		this.props.actions.labelGruposUsuario(
																			grupoUsuarios.descricao
																		);
																		this.props.actions.idGrupoUsuario(
																			grupoUsuarios.id
																		);
																		this.props.actions.novoFiltroFavoritoIsDefault(
																			false
																		);
																	}}
																>
																	{grupoUsuarios.descricao}
																</DropdownItem>
																{/* {!grupoUsuarios.isCompartilhadoGrupoUsuario && (
                          <div className='filtro-favoritos-botoes'>
                            <i
                              className={
                                grupoUsuarios.isDefault
                                  ? 'fas fa-star'
                                  : 'far fa-star'
                              }
                              onClick={() =>
                                this.atualizarFiltroFavoritoDefault(
                                  grupoUsuarios.isDefault
                                    ? !grupoUsuarios.isDefault
                                    : grupoUsuarios.value
                                )
                              }
                            ></i>
                            <i
                              className='fas fa-trash-alt'
                              onClick={() => this.abrirModalDeletar(grupoUsuarios)}
                            ></i>
                          </div>
                        )} */}
															</div>
														);
													}
												)}
											</div>
										</DropdownMenu>
									</Dropdown>
								</FormGroup>
							)}
						{!this.props.filtrosReducer.labelGruposUsuario && (
							<FormGroup check>
								<Label check>
									<Input
										type="checkbox"
										onChange={(event) => {
											this.props.actions.novoFiltroFavoritoIsDefault(
												event.currentTarget.checked
											);
										}}
									/>{' '}
									<IntlMessage id="dashboards.examDetails.startupFilter" />
								</Label>
							</FormGroup>
						)}
					</ModalBody>
					<ModalFooter>
						<Button onClick={this.showModalFavorito} color="secondary">
							<IntlMessage id="dashboards.examDetails.cancel" />
						</Button>
						<Button onClick={this.salvarFiltroFavorito} color="primary">
							<IntlMessage id="dashboards.examDetail.save" />
						</Button>
					</ModalFooter>
				</Modal>
				<Row
					className="pesquisa"
					style={{ borderBottom: '0', paddingBottom: '0' }}
				>
					<Col sm="auto" className={'marginBottom'}>
						<InputGroup>
							<InputGroupAddon addonType="prepend">
								<InputGroupText className="input">
									<IntlMessage id="dashboards.general.medicalRecord" />
								</InputGroupText>
							</InputGroupAddon>
							<Input
								innerRef={(el) => (this.buscaProntuario = el)}
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										this.filtroTemporarioParaClienteFelicioRocho(
											'14',
											'Prontuário',
											e.currentTarget.value
										);
									}
								}}
							/>
						</InputGroup>
					</Col>
					<Col sm="auto" className={'marginBottom'}>
						<InputGroup>
							<InputGroupAddon addonType="prepend">
								<InputGroupText className="input">
									<IntlMessage id="dashboards.general.examNumber" />
								</InputGroupText>
							</InputGroupAddon>
							<Input
								id="filtro-nrexame"
								innerRef={(el) => (this.buscaNrExame = el)}
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										this.filtroTemporarioParaClienteFelicioRocho(
											'8',
											'Número exame',
											e.currentTarget.value.toUpperCase()
										);
									}
								}}
							/>
						</InputGroup>
					</Col>
					<Col sm="auto" className={'marginBottom'}>
						<InputGroup>
							<InputGroupAddon addonType="prepend">
								<InputGroupText className="input">
									<IntlMessage id="dashboards.general.attendance" />
								</InputGroupText>
							</InputGroupAddon>
							<Input
								innerRef={(el) => (this.buscaAtendimento = el)}
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										this.filtroTemporarioParaClienteFelicioRocho(
											'13',
											'Atendimento',
											e.currentTarget.value
										);
									}
								}}
							/>
						</InputGroup>
					</Col>

					<Col className={'marginBottom'}>
						<InputGroup>
							<InputGroupButtonDropdown
								addonType="append"
								isOpen={this.props.filtrosReducer.dropdownOpen}
								toggle={() =>
									this.props.actions.dropdownOpen(
										!this.props.filtrosReducer.dropdownOpen
									)
								}
							>
								<DropdownToggle
									className="button"
									style={{ marginRight: '0px', marginLeft: 0 }}
									innerRef={(el) => (this.componenteFiltro = el)}
									caret
								>
									{this.props.filtrosReducer.labelFiltroSelecionado}
								</DropdownToggle>
								<DropdownMenu
									style={{ maxHeight: '435px', overflow: 'hidden scroll' }}
								>
									{this.props.filtrosReducer.filtros
										.filter((el) => el.id !== '-1')
										.map((filtro, i) => {
											if (filtro.id === '4') {
												return (
													<DropdownItem
														key={i}
														onClick={() => {
															this.select(
																filtro.label,
																filtro.id,
																filtro.tipo,
																'medicos'
															);
														}}
													>
														{filtro.value ? filtro.value : filtro.label}
													</DropdownItem>
												);
											}
											if (!['8', '12', '13', '14', '4'].includes(filtro.id)) {
												return (
													<DropdownItem
														key={i}
														onClick={() =>
															this.select(
																filtro.label,
																filtro.id,
																filtro.tipo,
																filtro.url
															)
														}
													>
														{filtro.value ? filtro.value : filtro.label}
													</DropdownItem>
												);
											} else {
												return <div key={i}></div>;
											}
										})}
								</DropdownMenu>
							</InputGroupButtonDropdown>
							{this.props.filtrosReducer.idFiltroSelecionado === '22' && (
								<UncontrolledButtonDropdown>
									<DropdownToggle className="button" caret>
										{this.props.filtrosReducer.labelFiltroStatusSelecionado}
									</DropdownToggle>
									<DropdownMenu>
										<DropdownItem onClick={this.atualizarLabelFiltroStatus}>
											<IntlMessage id="dashboards.examDetails.materialReceipt" />
										</DropdownItem>
										<DropdownItem onClick={this.atualizarLabelFiltroStatus}>
											<IntlMessage id="dashboards.examDetail.freezing" />
										</DropdownItem>
										<DropdownItem onClick={this.atualizarLabelFiltroStatus}>
											<IntlMessage id="dashboards.examDetails.macro" />
										</DropdownItem>
										<DropdownItem onClick={this.atualizarLabelFiltroStatus}>
											<IntlMessage id="dashboards.examDetails.micro" />
										</DropdownItem>
										<DropdownItem onClick={this.atualizarLabelFiltroStatus}>
											<IntlMessage id="dashboards.taskControl.immune" />
										</DropdownItem>
										<DropdownItem onClick={this.atualizarLabelFiltroStatus}>
											<IntlMessage id="dashboards.examDetails.fish" />
										</DropdownItem>
										<DropdownItem onClick={this.atualizarLabelFiltroStatus}>
											<IntlMessage id="dashboards.examDetails.cish" />
										</DropdownItem>
										<DropdownItem onClick={this.atualizarLabelFiltroStatus}>
											<IntlMessage id="dashboards.examDetails.histo" />
										</DropdownItem>
										<DropdownItem onClick={this.atualizarLabelFiltroStatus}>
											<IntlMessage id="dashboards.examDetails.step.pcr" />
										</DropdownItem>
										<DropdownItem onClick={this.atualizarLabelFiltroStatus}>
											<IntlMessage id="dashboards.examDetails.notes" />
										</DropdownItem>
										<DropdownItem onClick={this.atualizarLabelFiltroStatus}>
											<IntlMessage id="dashboards.examDetails.errata" />
										</DropdownItem>
										<DropdownItem onClick={this.atualizarLabelFiltroStatus}>
											<IntlMessage id="dashboards.examDetails.conclusion" />
										</DropdownItem>
										<DropdownItem onClick={this.atualizarLabelFiltroStatus}>
											<IntlMessage id="dashboards.examDetails.printed" />
										</DropdownItem>
									</DropdownMenu>
								</UncontrolledButtonDropdown>
							)}
							<Input
								className={this.props.filtrosReducer.tipoFiltroSelecionado !== 'text' ? 'display-none' : undefined}
								readOnly={this.props.filtrosReducer.tipoFiltroSelecionado !== 'text'}
								invalid={this.props.filtrosReducer.inputVazio}
								innerRef={(el) => (this.componenteBusca = el)}
								maxLength={this.props.filtrosReducer.labelFiltroSelecionado === 'CPF' ? 14 : 255}
								onChange={(e) => {
									if (this.props.filtrosReducer.labelFiltroSelecionado === 'CPF')
										this.validarCpf(e.target.value);
								}}
								onKeyPress={(e) => {
									if (
										(this.props.filtrosReducer.labelFiltroSelecionado === 'Laudo' ||
										 this.props.filtrosReducer.labelFiltroSelecionado === 'CPF') &&
										!CommonFunctions.onlyNumber(e.key)
									) {
										e.preventDefault();
									}

									if (e.key === 'Enter')
										this.adicionarButton();
								}}
							/>
							{this.props.filtrosReducer.tipoFiltroSelecionado === 'select' && this.props.filtrosReducer.labelFiltroSelecionado != "Diagnóstico" && (
								<div className="mv-select-flex" style={{ flex: 1 }}>
									<SelectComponent
										className={'select-filtro'}
										onChange={this.filtro}
										noOptionsMessage={() => this.translate('dashboards.reports.noItemsFound')}
										placeholder={'Selecione uma opção'}
										onKeyDown={this.onKeyDown.bind(this)}
										options={this.props.filtrosReducer.optionsFiltroInputTypeSelect}
										value={this.props.filtrosReducer.statusEtapaSelecionada}
									/>
								</div>
							)}

							{this.props.filtrosReducer.tipoFiltroSelecionado === 'select' && this.props.filtrosReducer.labelFiltroSelecionado === "Diagnóstico" && (
								<div className="mv-select-flex" style={{flex: 1}}>
									<SelectAsyncComponent
										className={'select-filtro'}
										cacheOptions
										defaultOptions
										defaultValue={{}}
										placeholder={this.translate("dashboards.reports.selectOption")}
										onInputChange={this.setCidDigitado}
										loadOptions={this.obterCIDPorTermo}
										onChange={this.filtro}
									/>
								</div>
							)}

							<Input
								className={
									this.props.filtrosReducer.tipoFiltroSelecionado !==
										'selectComEtapa'
										? 'display-none'
										: undefined
								}
								//style={{width: '100%' }}
								style={{flex: 'auto' }}
								type="select"
								onChange={(event) => {
									this.atualizarEtapaFiltro(event);
								}}
							>
								{this.props.filtrosReducer.optionsEtapasFiltro.map(
									(item, i) => {
										return (
											<option key={i} value={item.value}>
												{item.label}
											</option>
										);
									}
								)}
							</Input>
							<Input
								className={
									this.props.filtrosReducer.tipoFiltroSelecionado !==
										'selectComEtapa'
										? 'display-none'
										: undefined
								}
								//style={{width: '100%' }}
								style={{flex: 'auto' }}
								type="select"
								onChange={this.filtro}
							>
								{this.props.filtrosReducer.optionsFiltroInputTypeSelect.map(
									(item, i) => {
										return (
											<option key={i} value={item.value}>
												{item.label}
											</option>
										);
									}
								)}
							</Input>

							<Col  style={{
											width: this.state.period.value ? '100%' : 'auto',
											display:
												this.props.filtrosReducer.tipoFiltroSelecionado !== 'date' || this.props.filtrosReducer.labelFiltroSelecionado === "Data de nascimento"
													? 'none'
													: 'block',
										}} >
								<div className="form-group has-float-label">

									<SelectComponent
										isClearable
										className="filtro-data"
										noOptionsMessage={() => this.translate('dashboards.reports.noItemsFound')}
										name="form-field-period"
										placeholder={this.translate('dashboards.general.selectPeriod')}
										value={this.state.period}
										onChange={(e) => {
											this.periodChanged(e);
											e && e.value ? this.changeIntervalPeriod(e.value) : this.changeIntervalPeriod('todos');
										}}
										options={this.state.periods}
									/>
								</div>
							</Col>

							{this.state.period && this.state.period.value === 'outro' && (
								<React.Fragment>
									<DebounceInput
										name="periodoDe"
										type="date"
										style={{
											width: '130px',
											display:
												this.props.filtrosReducer.tipoFiltroSelecionado !== 'date'
													? 'none'
													: 'block',
										}}
										className="filtro-data"
										readOnly={
											this.props.filtrosReducer.tipoFiltroSelecionado !== 'date'
										}
										value={this.props.filtrosReducer.periodoDe}
										onChange={(value) => {
											this.props.actions.periodoDe(value.target.value);
										}}
										onKeyPress={(e) => this.validarEntradaEnter(e.target.value)}
									/>
									<DebounceInput
										name="periodoAte"
										type="date"
										style={{
											width: '130px',
											display:
												this.props.filtrosReducer.tipoFiltroSelecionado !== 'date'
													? 'none'
													: 'block',
										}}
										className="filtro-data"
										readOnly={
											this.props.filtrosReducer.tipoFiltroSelecionado !== 'date'
										}
										value={this.props.filtrosReducer.periodoAte}
										onChange={(value) => {
											this.props.actions.periodoAte(value.target.value);
										}}
										onKeyPress={(e) => this.validarEntradaEnter(e.target.value)}
									/>
								</React.Fragment>)}
							{this.props.filtrosReducer.tipoFiltroSelecionado === 'date' && this.props.filtrosReducer.labelFiltroSelecionado === "Data de nascimento" && (
								<React.Fragment>
									<DebounceInput
										inputRef={(el) => (this.componenteBuscaDate = el)}
										name="dataNascimento"
										type="date"
										style={{width: '130px', display: this.props.filtrosReducer.tipoFiltroSelecionado !== 'date' ? 'none' : 'block' }}
										className="filtro-data"
										readOnly={this.props.filtrosReducer.tipoFiltroSelecionado !== 'date'}
										value={this.props.filtrosReducer.dataNascimento}
										onChange={(value) => {
											this.props.actions.dataNascimento(value.target.value);
										}}
										onKeyPress={(e) => {
											if (e.key === 'Enter')
												this.adicionarButton();
										}}
									/>
								</React.Fragment>
							)}
						</InputGroup>
					</Col>
				</Row>

				<Row className="pesquisa" style={{ paddingTop: '0' }}>
					<Col className={'marginBottom'}>
						<InputGroup>
							<InputGroupAddon addonType="prepend">
								<InputGroupText className="input">
									<IntlMessage id="dashboards.general.patientBusinessName" />
								</InputGroupText>
							</InputGroupAddon>
							<Input
								name="paciente"
								innerRef={(el) => (this.buscaPaciente = el)}
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										this.filtroTemporarioParaClienteFelicioRocho(
											'12',
											'Paciente',
											e.currentTarget.value
										);
									}
								}}
							/>
						</InputGroup>
					</Col>

					<Col sm="auto">
						<Dropdown
							direction="down"
							isOpen={this.props.filtrosReducer.dropdownOpenFavoritos}
							toggle={() =>
								this.props.actions.dropdownOpenFavoritos(
									!this.props.filtrosReducer.dropdownOpenFavoritos
								)
							}
						>
							<DropdownToggle className="button" caret>
								<IntlMessage id="dashboards.examDetail.favorites" />
							</DropdownToggle>
							<DropdownMenu
								style={{ overflowY: 'scroll', overflowX: 'hidden' }}
							>
								<div
									style={{
										maxHeight: `${window.innerHeight - 200}px`,
									}}
								>
									{this.props.filtrosReducer.favoritos.map((favorito, i) => {
										return (
											<div
												style={{
													position: 'relative',
												}}
												key={i}
											>
												<DropdownItem
													style={{
														width: '200px',
														overflow: 'hidden',
														textOverflow: 'ellipsis',
														whiteSpace: 'nowrap',
													}}
													onClick={() => {
														this.props.filtrarfavorito(favorito.value);
														this.props.actions.labelFavoritoSelecionado(
															favorito.label
														);
													}}
												>
													{favorito.label}
												</DropdownItem>
												{!favorito.isCompartilhadoGrupoUsuario && (
													<div className="filtro-favoritos-botoes">
														<i
															className={
																favorito.isDefault
																	? 'fas fa-star'
																	: 'far fa-star'
															}
															onClick={() =>
																this.atualizarFiltroFavoritoDefault(
																	favorito.isDefault
																		? !favorito.isDefault
																		: favorito.value
																)
															}
														></i>
														<i
															className="fas fa-trash-alt"
															onClick={() => this.abrirModalDeletar(favorito)}
														></i>
													</div>
												)}
												{favorito.isCompartilhadoGrupoUsuario && (
													<div>
														<div
															className="filtro-favoritos-grupo"
															style={{ padding: '0 35px' }}
														>
															<i className="fas fa-user-friends"></i>
														</div>
														<div className="filtro-favoritos-botoes">
															<i
																className={
																	favorito.isDefault
																		? 'fas fa-star'
																		: 'far fa-star'
																}
																onClick={() =>
																	this.atualizarFiltroFavoritoDefault(
																		favorito.isDefault
																			? !favorito.isDefault
																			: favorito.value
																	)
																}
															></i>
															<i
																className="fas fa-trash-alt"
																onClick={() => this.abrirModalDeletar(favorito)}
															></i>
														</div>
													</div>
												)}
											</div>
										);
									})}
								</div>
							</DropdownMenu>
						</Dropdown>
					</Col>

					<Col sm="auto">
						<div style={{ marginTop: '-4px' }}>
							<BotaoComIcone
								onClick={this.adicionarButton.bind(this)}
								style={{ marginTop: '-2px' }}
								icone="mv-basico-pesquisar"
								height={38}
								primary
							>
								<IntlMessage id="dashboards.general.search" />
							</BotaoComIcone>
						</div>
					</Col>

					<Col sm="auto">
						<div style={{ marginTop: '-4px' }}>
							<BotaoComIcone
								className="btn btn-icon"
								color="secondary"
								onClick={this.showModalFavorito}
								style={{ marginLeft: 0 }}
								height={38}
								icone="mv-basico-salvar"
							>
								<IntlMessage id="dashboards.general.currentFilter" />
							</BotaoComIcone>
						</div>
					</Col>
				</Row>

				<Row className="parametros" style={{ alignItems: 'center', display: 'flex', justifyContent: 'start', width: '100%' }}>
					<Col sm="auto">
						<span className="filtro-numero-registros">
							{`${this.props.listagemExibido || 0}/${this.props.listagemTotal || 0
								}`}{' '}
							<IntlMessage id="dashboards.general.recordsFound" />
						</span>
					</Col>
					<Col sm="auto">
						<div>
							{this.props.filtrosReducer.filtrosSelecionados &&
								this.props.filtrosReducer.filtrosSelecionados.map(
									(filtro, i) => {
										const filters = this.enumFiltros.filter(
											(x) => x.id == filtro.id
										)[0];
										return (
											<Badge
												key={i}
												style={{ marginRight: '8px' }}
												color="primary"
											>
												<IntlMessage
													id={filters ? filters.value : filtro.param}
												/>
												: {`${filtro ? filtro.value : ''}`}
												<Button
													className="remover"
													onClick={() =>
														this.remover(filtro.param, filtro.value)
													}
												>
													x
												</Button>
											</Badge>
										);
									}
								)}
						</div>
					</Col>

					{this.props.filtrosReducer.filtrosSelecionados &&
						this.props.filtrosReducer.filtrosSelecionados.length > 0 && (
							<Col sm="auto">
								<Button
									className="limpar-filtro"
									color="link"
									onClick={this.limpar}
								>
									<IntlMessage id="dashboards.general.clearFilters" />
								</Button>
							</Col>
						)}

					<div style={{ justifyContent: 'end', display: 'flex', flex: 'auto', width: 'auto' }}>

						{/* ORDENAR POR */}
						<div>
							<Label>
								<IntlMessage id="dashboards.general.orderBy" />
							</Label>
							<Dropdown
								style={{ display: 'inline' }}
								isOpen={this.props.filtrosReducer.dropdownOpenOrdenacao}
								toggle={() =>
									this.props.actions.dropdownOpenOrdenacao(
										!this.props.filtrosReducer.dropdownOpenOrdenacao
									)
								}
							>
								<DropdownToggle
									className="button"
									caret
								/* style={{ borderColor: 'transparent' }} */
								>
									{this.props.filtrosReducer.labelOrdenacaoSelecionado}
								</DropdownToggle>
								<DropdownMenu>
									{initialState.ordenacao.map((ordem, i) => {
										return (
											<DropdownItem
												key={i}
												onClick={() => {
													this.props.setOrdenacao(
														ordem.value,
														this.props.filtrosReducer.sentidoOrdenacaoASC
													);
													this.props.actions.labelOrdenacaoSelecionado(
														ordem.label
													);
													this.props.filtrar(
														this.props.filtrosReducer.filtrosSelecionados,
														0,
														true,
														ordem.value
													);
												}}
											>
												{ordem.label}
											</DropdownItem>
										);
									})}
								</DropdownMenu>
							</Dropdown>
						</div>
					</div>
				</Row>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		usuario: state.usuario,
		mensagem: state.commonReducer.mensagemAlerta,
		timeout: state.commonReducer.timeoutAlerta,
		tipoAlerta: state.commonReducer.tipoAlerta,
		idAlerta: state.commonReducer.idAlerta,
		filtrosReducer: state.filtros,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		commonActions: bindActionCreators(commonActions, dispatch),
		actions: bindActionCreators(actions, dispatch),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(FiltroContainer);



// WEBPACK FOOTER //
// ./src/pages/main/filtros/filtro.container.js